import * as actionTypes from './actionTypes';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';
import { ProcessCipModel } from '../../models/ProcessCip';
import { PAGOEFECTIVO } from '@app/src/utils/validations/constants';

interface State {
  data: ProcessCipModel;
  paymentType: string;
  isFetching: boolean;
  errorMessage: string;
}

export const initialState: State = {
  data: {
    code: null,
    message: '',
    cipUrl: ''
  },
  paymentType: String(PAGOEFECTIVO),
  isFetching: false,
  errorMessage: ''
};

export const processCip = (state: State = initialState, action): State => {
  switch(action.type) {
    case actionTypes.FETCH_PROCESSCIP_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case actionTypes.FETCH_PROCESSCIP_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isFetching: false,
      };
    case actionTypes.FETCH_PROCESSCIP_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        errorMessage: ''
      };
    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    case actionTypes.SET_PAYMENT_TYPE:
      return {
        ...state,
        paymentType: action.paymentType
      }
    case actionTypes.RESET_PAYMENT_TYPE:
      return {
        ...state,
        data: initialState.data
      }
    default:
      return state;
  }
};
